export enum InputIconType {
  PERSON = 'user-icon',
  EMAIL = 'email-icon-blue',
  LOCK = 'lock-icon',
  CARD = 'card-icon',
}
